import { useDeleteDataHook, useGetDataHook, useSaveDataHook } from '@bymason/api-hooks-base';
import { accountClient, InviteUserModel } from '@bymason/controller-api';
import { useCallback } from 'react';

export { AccountModel, AppId, ControllerVersion, FeatureFlag, UserModel } from '@bymason/controller-api';

/**
 * React hook that asynchronously gets an account.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetAccount(clientToken: string) {
  const handleGetData = useCallback(() => {
    return accountClient.getAccount(clientToken);
  }, [clientToken]);

  return useGetDataHook(handleGetData);
}

/**
 * React hook that asynchronously invites a user to join an account via email
 * @returns HookArray
 * @HookArray [0] post method
 * @HookArray [1] void
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 */
export function useInviteUser(clientToken: string) {
  const handleSaveData = useCallback(
    (data: InviteUserModel) => {
      return accountClient.inviteUser(data, clientToken);
    },
    [clientToken]
  );
  return useSaveDataHook(handleSaveData);
}

/**
 * React hook that asynchronously deletes a user by id
 * @returns HookArray
 * @HookArray [0] delete method
 * @HookArray [1] error
 * @HookArray [2] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 */
export function useDeleteUser(clientToken: string) {
  const handleGetData = useCallback(
    (id: string) => {
      return accountClient.deletUser(id, clientToken);
    },
    [clientToken]
  );
  return useDeleteDataHook(handleGetData);
}
